class ShabibiAboutMarquee extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.about-marquee-track');
    this.inner = this.querySelector('.about-marquee-inner');
    
    if (!this.track || !this.inner) return;

    this.initMarquee();
    window.addEventListener('resize', this.initMarquee.bind(this));
  }

  initMarquee() {
    // Measure the first inner block to set the exact transform offset for a seamless loop
    const offset = this.inner.offsetWidth;
    this.track.style.setProperty('--marquee-offset', `-${offset}px`);
  }
}

if (!customElements.get('shabibi-about-marquee')) {
  customElements.define('shabibi-about-marquee', ShabibiAboutMarquee);
}
